<template>
  <div class="task-top-tool">
    <!-- <el-tooltip effect="dark" content="新建清单" placement="bottom" v-if="isBoss || currentUserIsAdmin">
      <wf-button icon="icon iconfont iconicon_enlarge" circle @click="addChecklist"></wf-button>
    </el-tooltip> -->
    <MessageInfo :projectId="projectId" @close="fetchProjectUnreadMessage" @taskClick="taskClick">
    </MessageInfo>
    <el-tooltip effect="dark" content="设置" placement="bottom">
      <el-dropdown @command="handleCommand" trigger="click">
        <div class="project-seiing">
          <i class="icon iconfont iconicon_settings_nor activeIconHover"></i>
          <!-- <span>设置</span> -->
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="projectSetting" v-if="isBoss || isAdmin || $permission('项目管理-更新项目')">项目设置</el-dropdown-item>
          <el-dropdown-item command="archivingTask">已归档任务</el-dropdown-item>
          <el-dropdown-item command="keyframes" v-if="(isBoss || isAdmin)">字段管理</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-tooltip>
    <el-tooltip effect="dark" content="成员" placement="bottom">
      <span class="list-type-member" @click="goto">
        <div class="project-seiing">
          <i class="icon iconfont iconicon_team_members activeIconHover"></i>
          <!-- <span>成员</span> -->
        </div>
      </span>
    </el-tooltip>
    <div class="right">
      <el-popover placement="bottom" min-width="278" :offset="40" trigger="click" ref="popover" v-model="show" @after-leave="closePopver">
        <tableModeHead @changeHead="origin" @hide="show = false" :projectId="projectId" :show="show" />
        <div slot="reference">
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import bus from '@/bus'
import MessageInfo from '@/components/messageInfo'
import msgApi from '@/services/api/realMessage/realMessage'
import { mapState } from 'vuex'
import tableModeHead from './tableModeHead'
export default {
  components: {
    MessageInfo,
    tableModeHead
  },
  props: ['projectId', 'projectName'],
  data() {
    return {
      messageList: [],
      editVisible: false,
      show: false,
      istemplateKeyChange: false
    }
  },
  watch: {
    projectId() {
      // this.fetchProjectUnreadMessage()
    }
  },
  created() {
    // this.fetchProjectUnreadMessage()
    bus.$on('fetchProjectUnreadMessage', () => {
      this.fetchProjectUnreadMessage()
    })
  },
  computed: {
    ...mapState('project/project', ['isAdmin'])
  },
  methods: {
    addChecklist() {
      bus.$emit('addChecklist')
    },
    handleCommand(val) {
      switch (val) {
        case "projectSetting":
          bus.$emit('editVisible', true)
          break;
        case "archivingTask":
          this.$router.push({ path: "/archivingTask", query: { project_id: this.projectId } })
          break;
        case "recycleBin":
          this.$router.push({ path: "/recycleTask", query: { project_id: this.projectId } })
          break;
        case 'keyframes':
          this.show = true
          break
      }
    },
    goto() {
      this.$router.push({
        path: "/projectMember",
        query: {
          projectId: this.projectId,
          projectName: this.projectName
        }
      });
    },
    taskClick(data) {
      this.$emit('taskClick', data)
    },
    fetchProjectUnreadMessage() {
      return msgApi.historyMessageLogs({
        project_id: this.projectId,
        is_read: 0,
        order_is_read: 'NOORDER',
        order_create_time: 'DESC',
        page: 1,
        number: 1000
      }).then(res => {
        this.messageList = res.data
      })
    },
    origin() {
      this.istemplateKeyChange = true
    },
    closePopver() {
      if (this.istemplateKeyChange) {
        this.istemplateKeyChange = false
        this.$emit('templateKeyChange', 1)
      }
    }
  }
}
</script>

<style lang="scss">
.task-top-tool {
  display: flex;
  width: 200px;
  justify-content: space-around;
  align-items: center;
  .project-seiing {
    color: rgba(32, 32, 32, 0.6);
    i {
      font-size: 18px;
    }
  }
  .add-list-btn {
    width: 24px;
    height: 24px;
    line-height: 24px;
    padding: 0;
  }
  .iconicon_enlarge {
    margin: 0;
    line-height: 24px;
  }
  .el-dropdown {
    color: #fff;
  }
}
</style>
